export enum RegularExpressions {
  'NUMBER' = '^-?\\d+(?:\\.\\d+)?$',
  'ALPHANUMERIC' = '^[a-zA-Z0-9-]*$',
  'CURRENCY' = '^\\d*\\.?\\d{0,2}$',
  'TOLL_MILE' = '^\\d+(?:\\.\\d+)?$'
}
